<div
    class="research-child-wrapper"
    [class.research-child-wrapper--mobile]="isMobile"
>
    <div class="order-header" *ngIf="isMobile">
        <div class="order-header__return">
            <button class="close-button" (click)="closeDetails()">
                <img src="./assets/icons/navigation/back-compact.svg" alt="arrow_back" />
            </button>
        </div>
        <div class="order-header__text">Информация по заказу</div>
        <div class="order-header__print"></div>
    </div>

    <div class="order-data" *ngIf="isMobile">
        <div class="order-data__date">
            {{ formatFullDate(selectedOrder?.regDate) }}
        </div>
        <div class="order-data__day">{{ getDay(selectedOrder?.regDate) }}</div>
    </div>
    <div *ngIf="loadingResearchList" class="loading">
        <loader type="page" message="Загружаем лаб.заказ..."></loader>
    </div>
    <div *ngIf="!loadingResearchList" class="research-child-infinity-scroll-container">
        <div class="research-header" [class.research-header--mobile]="isMobile">
            <span class="date-research" *ngIf="!isMobile">{{
                getDateOrder(selectedOrder?.dtSort)
            }}</span>
            <span class="name-research"
                >Заказ {{ selectedOrder?.researchId }}</span
            >
            <span class="count-research">
                {{ labOrdersChild.length }}
                {{
                    strEnd(labOrdersChild.length, "Биоматериал", [
                        "",
                        "а",
                        "ов"
                    ])
                }}
            </span>
        </div>

        <div
            class="research-child-list"
            [class.research-child-list--mobile]="isMobile"
        >
            <div class="name-research__mobile" *ngIf="isMobile">
                Заказ {{ selectedOrder?.researchId }}
            </div>
            <ng-container
            *ngIf="
                labOrdersChild.length > 0;
                then showLabOrderChild;
                else notShowLabOrderChild
            "
            ></ng-container>
            <ng-template #notShowLabOrderChild>
                <div class="no-lab-child">Результаты лабораторных исследований вы можете получить в клинике</div>
            </ng-template>
            <ng-template #showLabOrderChild>
                <ng-container *ngFor="let result of labOrdersChild; let i = index">
                    <div
                        class="research-child-item"
                        [class.research-child-item--mobile]="isMobile"
                        (click)="openDocReseachChildModal(result, $event)"
                        [class.disabled-item]="
                            result.textStatus.trim().toLowerCase() !== 'выполнен'
                        "
                    >
                        <!--  -->
                        <div
                            *ngIf="isMobile"
                            class="research-child-item__save"
                            (click)="
                                goPdf(
                                    result.researchId,
                                    $event,
                                    result.extResults,
                                    result.internalOrder
                                )
                            "
                        >
                            <mat-icon
                                *ngIf="
                                    result.textStatus.trim().toLowerCase() ===
                                        'выполнен' &&
                                    !loadingPdfIds.has(result.researchId)
                                "
                                svgIcon="print"
                                class="cls-btn-print cls-btn-icon-print-custom"
                            ></mat-icon>
                            <div
                                class="loader"
                                *ngIf="loadingPdfIds.has(result.researchId)"
                            ></div>
                            <!-- <img
                                *ngIf="loadingPdfIds.has(result.researchId)"
                                class="pdf-loader loader-rotate"
                                src="./assets/icons/actions/loading-button.svg"
                                alt=""
                            /> -->
                        </div>
                        <!-- /// -->
                        <div
                            class="research-child-row__name"
                            [class.research-child-row__name--mobile]="isMobile"
                        >
                            {{ result.specimen }}
                        </div>
                        <div
                            class="research-child-row__indicator"
                            *ngIf="isMobile"
                            [ngClass]="getStatusClassIcon(result.textStatus)"
                        >
                            <img
                                *ngIf="getStatusIndicator(result.textStatus)"
                                [src]="getStatusIndicator(result.textStatus)"
                                class="status-indicator-icon"
                            />
                        </div>

                        <div class="research-child-row__text" *ngIf="!isMobile">
                            <div
                                class="research-child-row__text_status"
                                [ngClass]="getStatusClass(result.textStatus)"
                            >
                                {{ getCapitalizedStatus(result.textStatus) }}
                            </div>
                            <div
                                class="research-child-item__save"
                                (click)="
                                    goPdf(
                                        result.researchId,
                                        $event,
                                        result.extResults,
                                        result.internalOrder
                                    )
                                "
                            >
                                <mat-icon
                                    *ngIf="
                                        result.textStatus.trim().toLowerCase() ===
                                            'выполнен' &&
                                        !loadingPdfIds.has(result.researchId)
                                    "
                                    svgIcon="print"
                                    class="cls-btn-print cls-btn-icon-print-custom"
                                ></mat-icon>
                                <div
                                    class="loader"
                                    *ngIf="loadingPdfIds.has(result.researchId)"
                                ></div>
                                <!-- <img
                                    *ngIf="loadingPdfIds.has(result.researchId)"
                                    class="pdf-loader loader-rotate"
                                    src="./assets/icons/actions/loading-button.svg"
                                    alt=""
                                /> -->
                            </div>
                        </div>
                    </div>
                    <div
                        class="research-child-expanded-content"
                        [class.slide-out]="closingItemId === result.researchId"
                        *ngIf="isMobile && isItemExpanded(result.researchId)"
                    >
                        <app-reseach-child-modal
                            class="modal-details"
                            [class.modal-details--embedded]="isMobile"
                            [pickedResearch]="result"
                        ></app-reseach-child-modal>
                        <!-- (close)="showDetails = false" -->
                    </div>
                </ng-container>
            </ng-template>
        </div>
    </div>
</div>
